<template>
  <!--  显示中国疫情实时地图，悬浮省份显示该省现存病例、新增病例。
默认为中国各省份现有病例地图，点击某个省份显示该省各市的病例图（视难度做地图形式或者柱状图/饼图）-->
  <div class="home">
    <el-container>
      <!--      顶部区域-->
      <el-header>
        <img alt="logo" src="https://i.loli.net/2021/06/15/SDpgCGMWbHIXAVs.png" class="logo1">
        <img src="https://i.loli.net/2021/06/15/FtnWQ4axqv9gALJ.png" alt="疫情侦测站" class="titleImg" />
        <img alt="logo" src="https://i.loli.net/2021/06/15/VngHNdCRhvktcS1.png" class="logo2">
      </el-header>
      <!--    页面主体区域-->
      <el-container>
        <!--        中央地图区域-->
        <el-container>
          <el-main>
            <!--            中央区域地图-->
            <div class="main_map">
              <div class="map">
                <MainContent></MainContent>
              </div>
            </div>
          </el-main>
        </el-container>
        <!--        右侧栏-->
        <el-aside>
          <div class="news">
            <News></News>
          </div>

        </el-aside>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import News from "./News";
import MainContent from "./MainContent";
export default {
  data() {
    return {
    };
  },
  methods: {
  },
  name: "Home",
  components: { News, MainContent },
};
</script>
<style lang="less" scoped>
html,
body {
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0;
}
.home {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: red; /* 不支持线性的时候显示 */
  /*background-image: linear-gradient(to bottom right, #00A5E5 , #9ADDF8);*/
  background-image: linear-gradient(120deg, #a1c4fd 0%, #c2e9fb 100%);
  /*background-image: linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%);*/
}
.home > .el-container > .el-container {
  height: 70%;
  width: 100%;
}
.el-container {
  height: 100%;
  color: white;
}
.el-header {
  /*background-color: #b3c0d1;*/
  color: #333;
  text-align: center;
  line-height: 50px;
  height: 13% !important;
  overflow: hidden;
  .titleImg {
    position: relative;
    top: 0.9375rem;
    //width: 548px;
    //height: 79px;
     width: 30.8125rem;
    height: 4.4375rem;

  }
  .logo1{
    position: absolute;
    left: 10%;
    top: 1%;
    width: 110px;
    height: 100px;
  }
  .logo2{
    position: absolute;
    right: 10%;
    top: 0;
    width: 150px;
    height: 150px;
  }
}

.el-aside {
  color: #333;
  text-align: center;
  width: 25% !important;
  height: 100%;
  padding: 20px 0;
  /*隐藏滚动条而不影响功能,适配火狐和IE*/
  scrollbar-width: none;
  -ms-overflow-style: none;
  background-color: #e9eef3;
  .news{
    width: 96%;
    background-image: linear-gradient(120deg, #a1c4fd 0%, #c2e9fb 100%);
  }

}
/*隐藏滚动条而不影响功能，适配Chrome*/
.el-aside::-webkit-scrollbar {
  width: 0 !important;
  display: none;
}
.el-main {
  background-color: #e9eef3;
  color: #333;
  /*border: 1px solid red;*/
  text-align: center;
  /*line-height: 160px;*/
  /*  隐藏溢出区域*/
  //overflow: hidden;
  height: 100%;

  .main_map {
    width: 100%;
    height: 100%;
    margin: 0;
    /*border: 1px solid red;*/
  }
  .map{
    width: 100%;
    height: 100%;
    position: relative;
  }
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
</style>
